import { createGlobalStyle, css } from 'styled-components';
import check from './assets/images/Vector.png';

const stepper = css`
  .stepper-wrap {
    margin-top: 20px;
  }

  .stepper-wrap .stepper-item {
    padding-bottom: 20px;
    position: relative;
    display: flex;
  }

  .stepper-wrap .stepper-item:not(:last-child):after {
    height: 100%;
    width: 2px;
    position: absolute;
    left: 15px;
    content: '';
    bottom: 0%;
    border: 1px solid #3a4554;
    box-sizing: border-box;
    z-index: 2;
  }

  .stepper-wrap .stepper-item .icon-wrap .icon {
    height: 30px;
    width: 30px;
    background-image: url(${check});
    background-size: 14px;
    background-color: white;
    border: 1px solid #3a4554;
    display: inline-block;
    border-radius: 50px;
    background-repeat: no-repeat;
    background-position-x: 50%;
    background-position-y: 50%;
    z-index: 3;
    position: relative;
  }

  .open .title-div-stepper {
    width: 100%;
    height: 10px;
    padding: 16px 16px;
    margin: 0px;
    display: flex;
    align-items: center;
    background: #3a4554;
  }

  .open .title-div-stepper .title {
    color: white !important;
    font-weight: 600 !important;
  }

  .close .description {
    display: none;
  }

  @keyframes closeCard {
    from {
      height: 100px;
    }
    to {
      height: 59px;
    }
  }

  .open .description {
    padding: 16px 16px !important;
  }

  .small-div {
    animation-name: closeCard;
    animation-duration: 1s;
  }

  .card-wrap {
    min-width: 470px;
  }

  .stepper-wrap .stepper-item .card-wrap.close {
    border: 1px solid #999;
    border-radius: 6px;
    padding: 16px 16px;
    background-color: white;
  }

  .stepper-wrap .stepper-item .card-wrap.open {
    border: 1px solid #999;
    border-radius: 6px;
    background-color: white;
    overflow: hidden;
  }

  .stepper-wrap .stepper-item .card-wrap .content {
    display: flex;
    flex-direction: column;
  }

  .stepper-wrap .stepper-item .card-wrap .title {
    font-size: 16px;
    margin: 0;
    color: #000;
    font-weight: 100;
    text-transform: capitalize;
  }

  .stepper-wrap .stepper-item .card-wrap .description {
    color: #000;
    font-size: 14px;
    margin-top: 7.5px;
    line-height: 1.5rem;
    min-width: 400px;
  }

  .stepper-wrap .stepper-item.pending .card-wrap {
    border-color: #3a4554;
  }

  .stepper-wrap .stepper-item.pending .icon {
    border: 1px solid #3a4554;
    background-image: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .stepper-wrap .stepper-item.pending .title {
    font-weight: 600;
  }

  .pending {
    color: #3a4554;
    font-size: 14px;
    font-weight: 700;
  }

  .stepper-wrap .stepper-item.started .card-wrap {
    border-color: #3a4554;
  }

  .stepper-wrap .stepper-item .card-wrap {
    border-color: #3a4554 !important;
    background: rgba(250, 250, 250, 0.61) !important;
    border: 1.5px solid rgba(215, 217, 219, 0.3) !important;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05) !important;
    border-radius: 8px !important;
  }

  .stepper-wrap .stepper-item.started .icon {
    background-color: #3a4554;
    border: 1px solid #3a4554;
    background-image: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .stepper-wrap .stepper-item.started .title {
    font-weight: 100;
  }

  .started {
    color: white;
    font-size: 14px;
    font-weight: 700;
  }

  .stepper-wrap .stepper-item.failed:after {
    border: 1px solid #c0becd;
    z-index: 1;
  }

  .stepper-wrap .stepper-item.failed .title {
    font-weight: 700;
  }

  .stepper-wrap .stepper-item.ongoing .icon {
    background: white;
    position: relative;
    box-shadow: 0 0 3px #dedbdb;
    z-index: 3;
  }

  .stepper-wrap .stepper-item.ongoing .icon:after {
    border-radius: 50px;
    content: '';
    background: green;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 6px;
    width: 6px;
  }

  .stepper-button-back {
    position: absolute;
    left: 15px;
    bottom: 10px;

    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;

    width: 70px;
    height: 32px;

    background: #ffffff;
    border: 1px solid #0077d5;
    border-radius: 7px;

    font-family: inherit;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */

    text-align: center;

    color: #0077d5;

    &:hover {
      cursor: pointer;
    }

    &:active {
      background: hsl(0, 0%, 95%);
    }
  }

  .stepper-button-next {
    position: absolute;
    right: 15px;
    bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px 8px 16px;
    gap: 4px;

    min-width: 69px;
    height: 32px;
    border: 0px solid black;
    background: #0077d5;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 7px;

    font-family: inherit;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */

    color: #ffffff;
    
    &:hover {
      cursor: pointer;
    }

    &:active {
      background: hsl(206, 100%, 37%);
    }

    &:disabled {
      background: #D9D9D9;
      color: #fff;
      cursor: auto;
    }
  }

  .w-10 {
    width: 50px;
  }

  .w-90 {
    width: 90%;
    max-width: 500px;
  }

  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }

`;

const GlobalStyle = createGlobalStyle`

  * {
    font-family: "Inter";
    font-weight: 400;
  }

  html,
  body {
    background-color: #2b3238;
  }

  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

  /* Document
    ========================================================================== */

  /**
  * 1. Correct the line height in all browsers.
  * 2. Prevent adjustments of font size after orientation changes in iOS.
  */

  html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }

  /* Sections
    ========================================================================== */

  /**
  * Remove the margin in all browsers.
  */

  body {
    margin: 0;
    padding: 0;
    border: 0;
  }

  main {
    display: block;
  }

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /* Text-level semantics
    ========================================================================== */

  /**
  * Remove the gray background on active links in IE 10.
  */

  a {
    background-color: transparent;
  }

  /**
  * 1. Remove the bottom border in Chrome 57-
  * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
  */

  abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
  }

  /**
  * Add the correct font weight in Chrome, Edge, and Safari.
  */

  b,
  strong {
    font-weight: bolder;
  }

  code,
  kbd,
  samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /**
  * Add the correct font size in all browsers.
  */

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /* Embedded content
    ========================================================================== */

  /**
  * Remove the border on images inside links in IE 10.
  */

  img {
    border-style: none;
  }

  /* Forms
    ========================================================================== */

  /**
  * 1. Change the font styles in all browsers.
  * 2. Remove the margin in Firefox and Safari.
  */

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
  }

  /**
  * Show the overflow in IE.
  * 1. Show the overflow in Edge.
  */

  button,
  input {
    /* 1 */
    overflow: visible;
  }

  /**
  * Remove the inheritance of text transform in Edge, Firefox, and IE.
  * 1. Remove the inheritance of text transform in Firefox.
  */

  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
  * Correct the inability to style clickable types in iOS and Safari.
  */

  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button;
  }

  /**
  * Remove the inner border and padding in Firefox.
  */

  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
  * Restore the focus styles unset by the previous rule.
  */

  button:-moz-focusring,
  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
  * Correct the padding in Firefox.
  */

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }

  /**
  * Add the correct vertical alignment in Chrome, Firefox, and Opera.
  */

  progress {
    vertical-align: baseline;
  }

  /**
  * Remove the default vertical scrollbar in IE 10+.
  */

  textarea {
    overflow: auto;
  }

  /**
  * 1. Add the correct box sizing in IE 10.
  * 2. Remove the padding in IE 10.
  */

  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  /**
  * Correct the cursor style of increment and decrement buttons in Chrome.
  */

  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  /**
  * 1. Correct the odd appearance in Chrome and Safari.
  * 2. Correct the outline style in Safari.
  */

  [type="search"] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  /**
  * Remove the inner padding in Chrome and Safari on macOS.
  */

  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  /* Interactive
    ========================================================================== */

  /*
  * Add the correct display in Edge, IE 10+, and Firefox.
  */

  details {
    display: block;
  }

  /*
  * Add the correct display in all browsers.
  */

  summary {
    display: list-item;
  }

  /* Misc
    ========================================================================== */

  /**
  * Add the correct display in IE 10+.
  */

  template {
    display: none;
  }

  /**
  * Add the correct display in IE 10.
  */

  [hidden] {
    display: none;
  }

  /* Stepper
  ========================================================================== */
  ${stepper}

  /* Select
    ========================================================================== */

  button[tabindex='0'] {
    background-color:  #009CFF33 !important;
    color: black
  }

  button[tabindex='0'], button[tabindex='0']:focus {
    background: linear-gradient(0deg, rgba(0, 156, 255, 0.2), rgba(0, 156, 255, 0.2)), #FFFFFF !important;
    color: black;
  } 

   li[tabindex='-1']:hover {
    background-color: #2B323840 !important;
    color: black;
  } 

  ul[tabindex='0']:focus{
    outline: none !important;
  }

  button:focus, button:focus-visible {
    box-shadow: none !important;
  }

  input[type="search"]:focus, input[type="search"]:focus-visible {
    box-shadow: none !important;
  }

  input[type="text"] {
    width: 271px
  }

`;

export { GlobalStyle };
